// extracted by mini-css-extract-plugin
export default {"button":"ToBackButton_button__LPVys","button_link":"ToBackButton_button_link__Gf9t9"};